module.exports = __webpack_public_path__ + "static/media/404_image.5943f19e.png";